/*
 * Copyright (c) 2022. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import * as yup from 'yup';
export var ExecutorConfigType;
(function (ExecutorConfigType) {
    ExecutorConfigType["local"] = "local";
    ExecutorConfigType["localdask"] = "localdask";
    ExecutorConfigType["dask"] = "dask";
    ExecutorConfigType["daskStatic"] = "dask-static";
})(ExecutorConfigType || (ExecutorConfigType = {}));
export const executorConfigSchema = yup.object({
    type: yup.string().oneOf(Object.values(ExecutorConfigType)).required(),
    cpu_request: yup.string().optional().nullable(),
    mem_request: yup.string().optional().nullable(),
    threads_per_worker: yup.number().positive().optional().nullable(),
    min_workers: yup.number().positive().optional().nullable(),
    max_workers: yup.number().positive().optional().nullable(),
    manually_trim_memory: yup.bool().optional().nullable(),
    scheduler: yup.string().oneOf(['threads', 'processes']).optional().nullable(),
    num_workers: yup.number().positive().optional().nullable(),
    scheduler_ip: yup.string().optional().nullable(),
});
//# sourceMappingURL=executor.js.map